module.exports = __webpack_public_path__ + "c9568cdc2d0dce03dd82a2018ecc091b.ttf";